module.exports = __webpack_public_path__ + "fonts/THICCCBOI-ExtraBold.3fbf1080.woff2";